angular.module('bmsApp.trugreen.schedule')
	.controller('SMScheduleCtrl',
		function ($state,
				  $scope,
				  ConfigService,
				  ActivitySvc,
				  EmployeeSvc,
				  $mdDialog,
				  $window,
				  notify,
				  $timeout,
				  $q,
				  TaxHelperSvc,
				  DirectionSvc,
				  SMJobSvc,
				  SMScheduleSvc,
				  uiCalendarConfig) {


			function init() {
				setDefaultEventView();


				self.calendar.uiConfig = {
					calendar: {
						minTime: "07:00:00",
						maxTime: "21:00:00",
						allDaySlot: false,
						editable: true,
						selectable: false,
						selectHelper: true,
						droppable: true,
						contentHeight: 'parent',
						firstDay: 1,
						nextDayThreshold: '00:00:00',
						displayEventTime: false,
						views: {
							agendaWeek: {
								columnFormat: 'ddd D/M'
							},
						},
						dayClick: function (date, jsEvent, view) {
							dayClick(date);
						},
						eventRender: function (event, element) {
							// event.startEditable = !event.locked;
						},
						eventClick: function (event, jsEvent, view) {
							if (event.type == 'activity') {
								editActivity(event);
							}
							else {
								eventClick(event.visitId);
							}
						},
						eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
							var toDate = angular.copy(event.start);
							var params = {
								visitId: event.visitId,
								toDate: toDate
							};
							let visit = {
								id: event.visit.id,
								visit_date: toDate.toISOString(),
							};
							SMJobSvc.checkVisitAvailability(visit, null, null)
								.then(function (response) {
									if (response.data.is_available) {
										SMScheduleSvc.move(params)
											.then(function (result) {
												notify({
													message: 'Schedule updated'
												});
												view.calendar.refetchEvents();
											}, function () {
												revertFunc();
											});
									} else {
										revertFunc();
										notify({
											message: 'Cannot save visit: employee is already booked, please check availability schedule',
											classes: 'error',
											duration: '0'
										});
									}
								}, function (errors) {
									revertFunc();
									notify({
										message: errors[0],
										classes: 'error',
										duration: '0'
									});
								});
						},
						eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
							var toDate = angular.copy(event.start);

							var params = {
								visitId: event.visit.id,
								toDate: toDate,
								newDuration: moment.duration(event.end - event.start)
									.asMinutes()
							};

							SMScheduleSvc.move(params)
								.then(function (result) {
									notify({
										message: 'Schedule updated'
									});
									view.calendar.refetchEvents();
								}, function () {
									revertFunc();
								});

						},
						dayRender: function (date, cell) {
							// cell.html(date.format('\#DDDD'));

						},
						eventRender: function (event, element) {
							var $title = element.find('.fc-title');
							$title.html($title.text());
						},
						loading: function (bool) {

						},
						eventAfterAllRender: function (view) {

						},
						eventDragStart: function (event, jsEvent, ui, view) {

						},
						header: {
							left: 'prev,next today',
							center: 'title',
							right: 'month,agendaWeek,agendaDay'
						},
						lang: 'en-GB'
					}


				};


				var allEventSources = {
					visits: {
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime),
									employees: (self.employeeIds) ? self.employeeIds : [],
									eventView: self.eventView,
								}
							};

							SMScheduleSvc.calendarEvents(config.params)
								.then(function (response) {
									var events = response.data.events;
									angular.forEach(events, function (event) {
										//event.title = (self.eventView === 'address') ? event.customerAddress : event.customerName;
									});
									callback(events);
								}, function () {
									console.log('Failed to load visit events');
								});
						}
					},
					activity: {
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime)
								}
							};

							ActivitySvc.calendarEvents(config.params)
								.then(function (response) {
									events = response.data.events;
									callback(events);
								}, function () {
									console.log('Failed to load activity events');
								});
						}
					}
				};

				$timeout(function () {
					angular.forEach(allEventSources, function (value) {
						uiCalendarConfig.calendars['calendar'].fullCalendar('addEventSource', value);
					});
				}, 0);

				loadEmployees(); // for technician filter

			}

			function setDefaultEventView() {
				var eventView = $window.localStorage['sm_schedule_event_view'];
				if (angular.isUndefined(eventView)) {
					$window.localStorage['sm_schedule_event_view'] = 'name';
					self.eventView = 'name';
				}
				else {
					self.eventView = $window.localStorage['sm_schedule_event_view'];
				}
			}

			function eventViewUpdated() {
				// TODO: Make event views into scopes so a reload isn't required
				$window.localStorage['tg_schedule_event_view'] = self.eventView;
				uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
			}

			function employeeChanged() {
				self.employeeIds = [];
				self.employeeAvailabilityCalendar.employees.length = 0;
				angular.forEach(self.employee, function (employee) {
					self.employeeAvailabilityCalendar.employees.push(employee.id);
					self.employeeIds.push(employee.id);
				});

				uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');

				if (self.selectedDate) {
					dayClick(self.selectedDate);
				}
			}

			function dayClick(date) {
				self.loadingDayDetail = true;
				self.selectedDate = date;
				uiCalendarConfig.calendars['calendar'].fullCalendar('select', date);
				$q.all({
					visitsForDate: SMScheduleSvc.forDate(date.format('YYYY-MM-DD'), {
						filter: {
							employees: self.employeeAvailabilityCalendar.employees
						}
					}),
					vatRate: TaxHelperSvc.setVatRate()
				})
					.then(function (responses) {
						self.visits = responses.visitsForDate.data.visit_collection;
					})
					.finally(function () {
						self.loadingDayDetail = false;
					});
			}

			function eventClick(visitId) {
				SMScheduleSvc.showEditVisitModal(visitId)
					.then(function (result) {
						if (result == 'merge') {
							SMScheduleSvc.showMergeVisitModal(visitId).then(function(result) {
								uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
							});
						}
						else {
							uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
						}
					});
			}

			function loadEmployees() {
				var employeeParams = {
					filter: {
						status: true
					}
				};

				EmployeeSvc.index(employeeParams)
					.then(function (response) {
						self.employeeOptions = response.data.employee_collection;
					});
			}

			function editVisit(visit) {
				eventClick(visit);
			}

			function skipPreviousDay() {
				dayClick(self.selectedDate.subtract(1, 'days'));
			}

			function skipNextDay() {
				dayClick(self.selectedDate.add(1, 'days'));
			}

			function addVisit() {
				SMScheduleSvc.showAddVisitModal()
					.then(function (result) {
						uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
					});
			}

			function preInvoiceJob(job) {
				return SMJobSvc.preinvoice({
					jobId: job.id
				})
					.then(function (response) {
						notify({
							message: 'Job successfully pre-invoiced'
						});
						angular.extend(job, {
							is_preinvoiced: true
						});
					}, function (error) {
						notify({
							message: error,
							classes: 'error'
						});
					});
			}

			function printWorksheets() {
				if (self.selectedDate) {
					SMScheduleSvc.printWorksheets({
						date: self.selectedDate.format('YYYY-MM-DD')
					});
				}
			}

			function printDirections() {
				if (self.selectedDate) {
					DirectionSvc.printDirections({
						date: self.selectedDate.format('YYYY-MM-DD')
					});
				}
			}

			var self = $scope.SMScheduleCtrl = {
				loading: false,
				loadingDayDetail: false,
				eventView: null,
				employeeIds: [],
				methods: {
					init: init,
					skipPreviousDay: skipPreviousDay,
					skipNextDay: skipNextDay,
					editVisit: editVisit,
					addVisit: addVisit,
					printWorksheets: printWorksheets,
					printDirections: printDirections,
					eventViewUpdated: eventViewUpdated,
					employeeChanged: employeeChanged,
					preInvoiceJob: preInvoiceJob
				},
				calendar: {
					uiConfig: null,
					eventSources: []
				},
				employeeAvailabilityCalendar: {
					employees: []
				}
			}

		});